import { Props } from "./types";
import { Link } from "react-scroll";
import Screen from "@/constants/screens";
import { useWindowSize } from "@/shared/hooks/useWindowSize";

const CarouselItemDesktop = ({ title, index }: Props): JSX.Element => {
  const { width } = useWindowSize();
  return (
    <div className={`lg:py-4`} key={index}>
      <Link
        activeClass="after:content-[''] after:absolute md:after:w-full lg:after:w-1/2 after:border-b-[1px] after:h-1 md:after:inset-x-auto lg:after:inset-x-0 md:after:left-0 after:bottom-0 after:mx-auto font-bold"
        className="text-base text-magenta md:pb-3 lg:pb-4 md:mb:4 relative hover:cursor-pointer inline-block"
        spy
        hashSpy
        offset={width < Screen.DESKTOP_1280 ? -80 : 0}
        to={`${index + 1}`}
      >
        {title}
      </Link>
    </div>
  );
};

export default CarouselItemDesktop;
